/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UnblockUserFromDormancyMutationVariables = {
    userId: string;
};
export type UnblockUserFromDormancyMutationResponse = {
    readonly unblockUserFromDormancy: {
        readonly user: {
            readonly " $fragmentRefs": FragmentRefs<"UnblockUserFromDormancy_user">;
        };
    } | null;
};
export type UnblockUserFromDormancyMutation = {
    readonly response: UnblockUserFromDormancyMutationResponse;
    readonly variables: UnblockUserFromDormancyMutationVariables;
};



/*
mutation UnblockUserFromDormancyMutation(
  $userId: ID!
) {
  unblockUserFromDormancy(userId: $userId) {
    user {
      ...UnblockUserFromDormancy_user
      id
    }
  }
}

fragment UnblockUserFromDormancy_user on User {
  id
  dormancyBlock {
    whenBlocked
    blockedBy
    blockReason
    whenExpires
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnblockUserFromDormancyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnblockFromDormancy",
        "kind": "LinkedField",
        "name": "unblockUserFromDormancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UnblockUserFromDormancy_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnblockUserFromDormancyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnblockFromDormancy",
        "kind": "LinkedField",
        "name": "unblockUserFromDormancy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActiveBlock",
                "kind": "LinkedField",
                "name": "dormancyBlock",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenBlocked",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blockedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "blockReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "whenExpires",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "61c5201a7e29f1c3b8a0d1d381151af2",
    "id": null,
    "metadata": {},
    "name": "UnblockUserFromDormancyMutation",
    "operationKind": "mutation",
    "text": "mutation UnblockUserFromDormancyMutation(\n  $userId: ID!\n) {\n  unblockUserFromDormancy(userId: $userId) {\n    user {\n      ...UnblockUserFromDormancy_user\n      id\n    }\n  }\n}\n\nfragment UnblockUserFromDormancy_user on User {\n  id\n  dormancyBlock {\n    whenBlocked\n    blockedBy\n    blockReason\n    whenExpires\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '6444732c6f1235a27df6ff11696e1144';
export default node;
